// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"8275df02","511":"36d0f3fb","829":"2ea63208"}[chunkId] + ".chunk.js";
};